import { Strike } from './strike.js'

export * from './strike.js'

export default Strike
